import {GlobalVariables} from "../GlobalVariables";

export default class BlockKeynumberTextVideo {
    static init() {
        this.blocks = document.querySelectorAll('.block-keynumbers-text-video');

        if (this.blocks && this.blocks.length > 0) {
            this.moveBlock3();
            GlobalVariables.resizeCallbacks.push(this);
        }

    }

    static moveBlock3() {
        function getRemInPx() {
            return parseFloat(getComputedStyle(document.documentElement).fontSize);
        }

        this.blocks.forEach((block) => {
            const block2 = block.querySelector('.grid-item-2');
            const block3 = block.querySelector('.grid-item-3');
            block3.style.marginTop = 0;

            if (window.innerWidth >= 768 && block2 && block3) {
                const bottom2 = block2.getBoundingClientRect().bottom;
                const top3 = block3.getBoundingClientRect().top;
                const distance = top3 - bottom2;
                const targetOffset = distance - (getRemInPx() * 4);

                console.log(distance);

                block3.style.marginTop = `-${targetOffset}px`;
            }
        });
    }

    static resize() {
        this.moveBlock3();
    }
}